module.exports = __webpack_public_path__ + "static/media/collapse-arrow-down.a4b7ca21.svg";